import { Integration } from "../_modelsTS/Integration";
import { GenericCollectionFactory } from "../_generics";

export const IntegrationStore = GenericCollectionFactory<Integration>("INTEGRATIONS", "uid");